import { CludoConcernSearch } from 'ui/components';
import { useSiteContext } from 'application/contexts/SiteContext';

export const CludoConcernSearchFeature: React.FC<Content.CludoConcernSearch> = ({ content }) => {
    const siteContext = useSiteContext();
    const cludoEngineId = siteContext.cludoEngineId;

    return (<CludoConcernSearch {...content?.properties} cludoEngineId={cludoEngineId} />)
};
